<template>
  <b-modal
    v-model="isVisible"
    v-bind="$attrs"
    v-on="$listeners"
    size="lg"
    hide-footer
    no-close-on-backdrop
    centered
    :modal-class="['log-time-form-modal', $attrs['modal-class'], loading ? 'loading' : '']"
    header-class="log-time-form-modal-header"
  >
    <template v-slot:modal-header="{ cancel }">
      <ModalHeader :title="title" :onCloseButton="cancel" :closeButtonId="id" />
    </template>
    <slot></slot>
  </b-modal>
</template>

<script>
import ModalHeader from '@components/modals/ModalHeader.vue'

export default {
  name: 'LogTimeReportFormModal',
  components: { ModalHeader },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    id: { type: String },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .log-time-form-modal {
  .modal-dialog {
    width: 792px;
  }

  .log-time-form-modal-header {
    padding-top: 15px;
    padding-bottom: 10px;
  }
}
</style>
